import {
    GENESIS_GET_ORDER,
    GENESIS_GET_ORDER_SUCCESS,
    GENESIS_GET_ORDER_ERROR,
    GENESIS_POST_ORDER,
    GENESIS_POST_ORDER_SUCCESS,
    GENESIS_POST_ORDER_ERROR,
    GENESIS_GET_ORDER_INCOMPLETE_SUCCESS,
    GENESIS_RESET_ORDER_INCOMPLETE_SUCCESS,
    GENESIS_RESET_ORDER_SUCCESS,
} from '@/components/orderGenesis/redux/types/OrderTypes';

import axios from 'axios';
export const getOrderGenesis = () => {
    return {
        type: GENESIS_GET_ORDER,
    };
};
export const getOrderSuccessGenesis = (result) => {
    return {
        type: GENESIS_GET_ORDER_SUCCESS,
        value: result,
    };
};
export const getOrderErrorGenesis = (error, result) => {
    return {
        type: GENESIS_GET_ORDER_ERROR,
        value: error,
        payload: result,
    };
};

export function fetchGetOrderGenesis(order, token) {
    const headers = {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
    };
    return async (dispatch) => {
        dispatch(getOrderGenesis());
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/v2/purchase-order/${order}`,
                {headers}
            );
            dispatch(getOrderSuccessGenesis(response.data));
        } catch (error) {
            dispatch(getOrderErrorGenesis(true));
        }
    };
}

export const postOrderGenesis = () => {
    return {
        type: GENESIS_POST_ORDER,
    };
};
export const postOrderSuccessGenesis = (result) => {
    return {
        type: GENESIS_POST_ORDER_SUCCESS,
        value: result,
    };
};
export const postOrderErrorGenesis = (error, message, result) => {
    return {
        type: GENESIS_POST_ORDER_ERROR,
        value: error,
        payload: result,
        message: message,
    };
};

export function fetchPostOrderGenesis(orderId, data, token) {
    const headers = {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
    };
    return async (dispatch) => {
        dispatch(postOrderGenesis());
        try {
            const response = await axios.patch(
                `${process.env.REACT_APP_BASE_URL}/v2/purchase-order/${orderId}`,
                data,
                {
                    headers,
                }
            );
            if (response.data.error) {
                dispatch(postOrderErrorGenesis(true, response.data.message));
                window.location.href = '/genesis-ordersuccess';
            } else {
                dispatch(postOrderSuccessGenesis(response.data.data));
                dispatch(postOrderErrorGenesis(false, ''));
                window.location.href = '/genesis-ordersuccess';
            }
        } catch (error) {
            dispatch(postOrderErrorGenesis(true, ''));
        }
    };
}

export const getOrderIncompleteSuccessGenesis = (result, order, referenceId) => {
    return {
        type: GENESIS_GET_ORDER_INCOMPLETE_SUCCESS,
        value: result,
        order: order,
        referenceId: referenceId,
    };
};
export const resetOrderIncompleteSuccessGenesis = () => {
    return {
        type: GENESIS_RESET_ORDER_INCOMPLETE_SUCCESS,
    };
};

export const resetOrderSuccessGenesis = () => {
    return {
        type: GENESIS_RESET_ORDER_SUCCESS,
    };
};
